import { Component, OnInit, TemplateRef, ChangeDetectorRef, AfterViewInit} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../services/admin.service";
import { apiUrl } from "../../global/global";
import { UserDetailsService } from "src/app/services/user/user-details.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { DatePipe } from "@angular/common"
import * as Highcharts from "highcharts";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsSolidGauge from "highcharts/modules/solid-gauge";
import { EChartsOption } from "echarts";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";

HighchartsMore(Highcharts);
HighchartsSolidGauge(Highcharts);

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"]
})
export class DashboardComponent implements OnInit{
  Highcharts: typeof Highcharts = Highcharts;
  public userDatas: any;
  allData:any; 
 
  inventoryByMonthLable : any = []
  inventoryByMonthValue : any = []

  topUserEmailSentData : any = []
  topTenInventoryUsedByUserData : any = []
  emailCampaignSentData : any = []
  emailCampaignOpenData : any = []
  emailCampaignClickData : any = []
  
  color= ["#AF6F50","#8FAD51","#AF7B48","#4F4F7E","#A75050","#A28D55","#8B8B8B","#517595","#935A91","#D8905E","#4D7DAD","#51ACAC",]

  isShowDiv = false;
  
  OnClick() {
    this.isShowDiv = !this.isShowDiv;
  }

  maxDate: Date;
  today: Date;
  invalidDateFilter = false;
  fromDate: any;
  toDate: any;
  show = 0;
  filterForm: FormGroup;
  modalRef?: BsModalRef;
  config = {
    backdrop: true,
    ignoreBackdropClick: false
  };
  showError = false;
  noDataFound = false;
  showNewUser = false;

  constructor( public route: ActivatedRoute,  private router: Router, private api: AdminService, public datePipe: DatePipe,private userDetailsService: UserDetailsService, private formBuilder: FormBuilder,private modalService: BsModalService, private ref:ChangeDetectorRef) { 
    this.userDetailsService.getRecruiterUserData();
    this.userDetailsService.userDetailsObserver.subscribe(userData => {
      this.userDatas = userData;
    });
    this.filterForm = this.formBuilder.group({
      startDate: new FormControl("", [Validators.required]),
      endDate: new FormControl("", [Validators.required]),
    });
    this.today = new Date();
    this.maxDate = new Date(this.today.getDate() + 3);
  } 
  ngOnInit(): void {
    this.getDashboard(); 
  }
   
  getDashboard(){
    let params = new HttpParams();
    if (this.fromDate) {
      params = params.append("startDate", this.fromDate);
    }
    if (this.toDate) {
      params = params.append("endDate", this.toDate);
    } 
    this.api.getData(apiUrl._recruiterDashboard,params)
    .subscribe(async (res) => {   
      this.inventoryByMonthLable=[] 
      this.inventoryByMonthValue=[]  
      this.topUserEmailSentData=[]  
      this.topTenInventoryUsedByUserData=[]  
      this.emailCampaignClickData=[]  
      this.emailCampaignSentData=[]  
      this.emailCampaignOpenData=[]
      this.allData =res.data;  
      console.log(this.allData);
      this.noDataFound = true;
      for (let inventory of this.allData.inventoryUsedByMonth) { 
        if(inventory.count > 0){
          this.noDataFound = false
        }
        this.inventoryByMonthLable.push(inventory.month);
        this.inventoryByMonthValue.push(inventory.count);
      }
    
      for (let data of this.allData.topTenUserEmailSent) {
        if(data.count > 0){
          this.noDataFound = false
        }
        this.topUserEmailSentData.push({
          name: data.userName,
          y: data.count,
        });
      }
      for (let data of this.allData.topTenInventoryUsedByUser) {
        if(data.count > 0){
          this.noDataFound = false
        }
        this.topTenInventoryUsedByUserData.push({
          name: data?.recruiter?.name,
          y: data.count,
        });
      }
      for (let data of this.allData.emailCampaignClick) { 
        if(data.count > 0){
          this.noDataFound = false
        }
        this.emailCampaignClickData.push({
          name: data.month,
          y: data.count,
        });
        
      }
      for (let data of this.allData.emailCampaignSent) { 
        if(data.count > 0){
          this.noDataFound = false
        }
        this.emailCampaignSentData.push({
          name: data.month,
          y: data.count,
        });
      }
      for (let data of this.allData.openRates) { 
        this.emailCampaignOpenData.push({
          name: data.month,
          y: data.count,
        });
      }
      this.createChartColumn();
      this.ref.detectChanges()
    // }
    })
  } 
    
  // echart
  options: EChartsOption = {
    color: ["#4D7DAD","#51ACAC","#AF6F50","#8FAD51","#AF7B48","#4F4F7E","#A75050","#A28D55","#8B8B8B","#517595","#935A91","#D8905E"],
    
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        data: this.inventoryByMonthLable,
        axisTick: {
          alignWithLabel: true,
        },
      },
    ],
    yAxis: [
      {
        type: "value",
      },
    ],
    series: [
      {
        name: "Counters",
        type: "bar",
        barWidth: "60%",
        data: this.inventoryByMonthValue, 
      },
    ],
    graph: {
      color: this.color
    }
  };
  // hightchart 
 
  private createChartColumn(): void { 
   
    const chart= Highcharts.chart("chart-column" as any, {
      color: ["#4D7DAD","#51ACAC","#AF6F50","#8FAD51","#AF7B48","#4F4F7E","#A75050","#A28D55","#8B8B8B","#935A91"],
      chart: {
        type: "column"
      },
      title: {
        text: ""
      },
      xAxis: {
        type: "category",
        categories: this.inventoryByMonthLable,
      },
      yAxis: {
        min: 0,
        title: "",
        labels: {
          overflow: "justify"
        }
      }, 
      plotOptions: {
        column: {
          colorByPoint: true,
          dataLabels: {
            enabled: true,
            crop: false,
            overflow: 'none'
        }
        }
      },
      legend: {
        enable: false
      },
      credits: {
        enabled: false
      },
      series: [
        {
          name: "Inventory used by month",
          data: this.inventoryByMonthValue}
      ]
    
      } as any);
    const chart1 = Highcharts.chart("bar-Horizontal" as any, {
      
    color: ["#4D7DAD","#51ACAC","#AF6F50","#8FAD51","#AF7B48","#4F4F7E","#A75050","#A28D55","#8B8B8B","#935A91"],
    chart: {
      type: "bar"
    },
    title: {
      text: ""
    },
    xAxis: {
      type: "category",
    },
    yAxis: {
      min: 0,
      title: "",
      labels: {
        overflow: "justify"
      }
    }, 
    plotOptions: {
      series: {
          pointWidth: 15,
      },
      bar: {
        colorByPoint: true,
        dataLabels: {
          enabled: true
        }
      }
    },
    legend: {
      enable: false
    },
    credits: {
      enabled: false
    },
    series: [
      {
        name: "Top 10 inventory usage users",
        data: this.topTenInventoryUsedByUserData,}
    ]
  
    } as any);
    const chart2 = Highcharts.chart("bar-Horizontal2" as any, {
      color: ["#4D7DAD","#51ACAC","#AF6F50","#8FAD51","#AF7B48","#4F4F7E","#A75050","#A28D55","#8B8B8B","#935A91"],
      chart: {
        type: "bar",
        inverted: true
      },
      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      yAxis: {
        min: 0,
        title: "",
        labels: {
          overflow: "justify"
        }
      },
      xAxis: {
        type: "category",
      },
      tooltip: {
        headerFormat: `<div style="text-transform: capitalize;">{point.key}</div>`,
        pointFormat: `<div>{series.name}: {point.y}</div>`,
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        series: {
            pointWidth: 15
        },
        bar: {
          colorByPoint: true,
          dataLabels: {
            enabled: true,
          },
        },
      },
      legend: {
        enable: false
      },
      series: [{
        name: "Top 10 users by email sent",
        data: this.topUserEmailSentData,
      }],
    } as any);
    // sent mail summary
    
    const chart3= Highcharts.chart("chart-barLine" as any, {
      color: ["#4D7DAD","#51ACAC","#AF6F50","#8FAD51","#AF7B48","#4F4F7E","#A75050","#A28D55","#8B8B8B","#935A91"],
      chart: {
        type: "column"
      },
      title: {
        text: ""
      },
      xAxis:[{
        categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun","Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        crosshair: true
    }],
    plotOptions: {
      column: {
        colorByPoint: true,
        dataLabels: {
          enabled: true
        }
      }
    },
    yAxis: [
      { // Sent email
        labels: {
            format: "{value}",
        },
        title: {
            text: "Sent email",
        }
    },  // Open/click rate
    {
        title: {
            text: "Open/click rate",
            
        },
        labels: {
            format: "{value} %",
        },
        opposite: true
    }, // bar yAxis
    {
        title: {
            text: "",
            style: {
              color:["#4D7DAD","#51ACAC","#AF6F50","#8FAD51","#AF7B48","#4F4F7E","#A75050","#A28D55","#8B8B8B","#935A91"]
          }
        },
    },], 
    tooltip: {
      headerFormat: `<div>Month: {point.key}</div>`,
      pointFormat: `<div>{series.name}: {point.y}</div>`,
      shared: true,
      useHTML: true,
    },
  legend: {
     enable: false,
      // align: "left",
      // x: 0,
      // verticalAlign: "top",
      // y: 0,
      // floating: false, 
  },
  series: [{
      name: "Sent Email",
      type: "column",
      // yAxis: 1,
      data:this.emailCampaignSentData,
  // }, {
  //     name: "Email Campaign",
  //     type: "column",
  //     data: this.emailCampaignClickData,
  }, {
      name: "Open click Rate",
      type: "spline",yAxis: 1,
      data:this.emailCampaignOpenData,
  }]
    
      } as any);
  }

  openModal(template: TemplateRef<any>) {
    this.modalService.show(template);
  }
  close() {
    this.modalRef?.hide();
  }
  
  applyFilter(modal: any) {
    this.fromDate = this.datePipe.transform(
      this.filterForm.value.startDate,
      "yyyy-MM-dd"
    );
    this.toDate = this.datePipe.transform(
      this.filterForm.value.endDate,
      "yyyy-MM-dd"
    );
    if (this.filterForm.valid) {
      if (this.fromDate && this.toDate) {
        if (this.fromDate > this.toDate) {
          this.invalidDateFilter = true;
          setTimeout(() => {
            this.invalidDateFilter = false;
          }, 4000);
          return;
        }
      }
      this.getDashboard();
      this.show = 1;
      this.modalService.hide();
    } else {
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 3000);
      return;
    }
  }

  clearFilter(modal: any) {
    this.filterForm.reset();
    this.fromDate = "";
    this.toDate = "";
    this.show = 0;
    this.modalRef?.hide();
    this.modalService.hide();
    this.getDashboard();
  }
}
